<template>
  <div class='app_container'>
    <div class="language_bg">
      <el-dropdown>
        <div>{{curLanguage}}</div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item,index) in languageList" :key='index' @click.native="changeLanguage(item.languageType)" >
            {{item.language}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="language-arrow-down"></div>
    </div>
    <div class='desc_container'>
      <a href='https://www.contentos.io'>
        <img class='logo' src='../assets/img/logo.png'>
      </a>
      <div class="desc_text" v-html="$t('message.service_desc')"></div>
    </div>
    <div v-if="serviceAvailable" class='operate_container'>
      <!--Get token list stage-->
      <template v-if='checkIsGetTokenListStage()'>
        <tokenListView :ref=tokenListViewRef :token-list='tokenList'></tokenListView>
      </template>
      <!--Get deposit info stage-->
      <template v-else-if='checkIsGetDepositInfoStage()'>
        <depositInfoView :ref=depositInfoViewRef :deposit-info='depositInfo'></depositInfoView>
      </template>
      <!--Start swap stage-->
      <template v-else-if='checkIsSwapStage()'>
        <swapResultView :ref=swapResultViewRef :swap-result='swapResult' :deposit-info='depositInfo'></swapResultView>
      </template>
      <!--next button-->
      <button v-if="tokenList.length" :class="[checkIsGetTokenListStage()?'next_btn':'startOverBtn']" @click='onclickNextBtn()'>{{getNextBtnTitle()}}</button>
      <router-link v-show="!isShowLoading" to="/records" class="records_link">
        {{ $t('message.conversion_record') }}
        <span class="new_badge">{{ $t('message.new_label') }}</span>
      </router-link>
      <loadingView v-show="isShowLoading"></loadingView>
    </div>
    <div v-else class="out_of_service">
      <el-alert
        title="Service temporarily unavailable"
        description="An unsuccessful token swap was detected in the past 20 minutes. We will resume the service as soon as the problem is resolved. We appreciate your understanding. YOUR FUND IS SAFE."
        type="warning"
        effect="dark"
        :closable="false"
        show-icon>
      </el-alert>

    </div>
    <el-footer v-show="!isShowLoading">
      <a class="service_mail" href='mailto:service@contentos.io'>service@contentos.io</a>
    </el-footer>
  </div>
</template>

<script>
import utils from '../common/utils'
import tokenListView from '../components/tokenListView'
import depositInfoView from '../components/depositInfoView'
import swapResultView from '../components/swapResultView'
import webAPI from '../common/webService'
import loadingView from '../components/loading'
import i18n from '../i18n/i18n'
const addrInputId = 'addrInputId'

export default {
  name: 'home',
  components: {
    tokenListView,
    depositInfoView,
    swapResultView,
    loadingView
  },
  data () {
    return {
      tokenList: [],
      curStage: utils.SwapStage.SwapStageGetTokenList, // current handle stage
      curSwapType: utils.SwapType.SwapTypeErc20ToBep2, // current swap type
      swapAddress: '',
      exChangeMemo: '',
      tokenListViewRef: 'tokenListView',
      depositInfoViewRef: 'depositInfoView',
      swapResultViewRef: 'swapResultView',
      depositInfo: {},
      swapResult: [],
      isQuerying: false,
      isShowLoading: false,
      languageList: this.getLanguageList(),
      curLanguageType: utils.languageType.languageTypeEn,
      curLanguage: 'English',
      serviceAvailable: true
    }
  },
  methods: {
    getCurrentLanguageType () {
      let local = i18n.locale
      if (utils.checkIsSupportLanguage(local)) {
        return i18n.locale
      } else {
        this.$i18n.locale = utils.languageType.languageTypeEn
        console.log('not support language type:', local)
      }

      return utils.languageType.languageTypeEn
    },

    getCurrentLanguage () {
      console.log('curLanguageType is', this.curLanguageType)
      for (let info of this.languageList) {
        if (this.curLanguageType === info.languageType) {
          return info.language
        }
      }
      return 'English'
    },

    changeLanguage (val) {
      if (this.curLanguageType !== val) {
        for (let info of this.languageList) {
          if (info.languageType === val) {
            this.curLanguage = info.language
            this.curLanguageType = val
            this.$i18n.locale = val
            sessionStorage.setItem('locale', val)
          }
        }
      }
    },

    getLanguageList () {
      return [{ languageType: utils.languageType.languageTypeTW, language: '繁體中文' },
        { languageType: utils.languageType.languageTypeCN, language: '简体中文' },
        { languageType: utils.languageType.languageTypeEn, language: 'English' },
        // { languageType: utils.languageType.languageTypeJa, language: '日本語' },
        { languageType: utils.languageType.languageTypeKo, language: '한국어' },
        { languageType: utils.languageType.languageTypeVietnam, language: 'Tiếng việt' },
        // { languageType: utils.languageType.languageTypePortugal, language: 'Português' },
        { languageType: utils.languageType.languageTypeRussian, language: 'Русский' }]
    },

    checkIsGetTokenListStage () {
      return this.curStage === utils.SwapStage.SwapStageGetTokenList
    },

    checkIsGetDepositInfoStage () {
      return this.curStage === utils.SwapStage.SwapStageGetDepositInfo
    },

    checkIsSwapStage () {
      return this.curStage === utils.SwapStage.SwapStageSwap
    },

    getTokenDesc () {
      if (this.curTokenType === utils.TokenType.TokenTypeErc20) {
        return 'Eth chain Token'
      } else if (this.curTokenType === utils.TokenType.TokenTypeBep2) {
        return 'Eth chain Token'
      } else if (this.curTokenType === utils.TokenType.TokenTypeCosMainNet) {
        return 'Eth chain Token'
      }
      return ''
    },

    getTokenAddressDesc () {
      if (this.curTokenType === utils.TokenType.TokenTypeErc20) {
        return 'Eth Address'
      } else if (this.curTokenType === utils.TokenType.TokenTypeBep2) {
        return 'BNB Address'
      } else if (this.curTokenType === utils.TokenType.TokenTypeCosMainNet) {
        return 'Cos Account'
      }
      return ''
    },

    changeTokenType () {
      let swapType = this.curTokenType
      if (utils.checkIsSwapToErc20(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeErc20
      } else if (utils.checkIsSwapToBep2(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeBep2
      } else if (utils.checkIsSwapToCosMainNet(swapType)) {
        this.curTokenType = utils.TokenType.TokenTypeCosMainNet
      }
    },

    getSwapTokenAddress () {
      let addrInput = document.getElementById(addrInputId)
      let val = addrInput.value
      return val
    },

    getAddressPlaceholder () {
      if (this.curTokenType === utils.TokenType.TokenTypeErc20) {
        return 'eg:0xcE46FCEC0e6D568B78b90d64803038ceC6B4eDed'
      } else if (this.curTokenType === utils.TokenType.TokenTypeBep2) {
        if (process.env.NODE_ENV === 'production') {
          return 'eg:bnb1mmxvnhkyqrvd2dpskvsgl8lmft4tnrcs97apr3'
        }
        return 'eg:tbnb1hvsh83e5ttdl6t3ngmysy0k2l5yxfw23862nx3'
      } else if (this.curTokenType === utils.TokenType.TokenTypeCosMainNet) {
        return 'eg:initminer'
      }
      return ''
    },

    getNextBtnTitle () {
      if (this.curStage !== utils.SwapStage.SwapStageGetTokenList) {
        return this.$t('message.start_over_btn')
      }
      return this.$t('message.next_btn')
    },

    async onclickNextBtn () {
      // if current stage is SwapStageGetTokenList,when click next, fetch the deposit info and then enter stage SwapStageGetDepositInfo
      if (this.checkIsGetTokenListStage()) {
        let info = this.$refs.tokenListView.getSwapInfo()
        this.curSwapType = info.swapType
        this.swapAddress = info.address
        this.exChangeMemo = info.exChangeMemo
        if (this.swapAddress.length < 1) {
          utils.showAlert(this.$t('message.tips'), this.$t('message.enter_address_tips'))
        } else {
          if ((utils.checkIsBnbExchangeAddr(this.swapAddress) && utils.checkIsSwapToBep2(this.curSwapType)) || (utils.checkIsCosMainNetExchangeAddr(this.swapAddress) && utils.checkIsSwapToCosMainNet(this.curSwapType))) {
            // check exchange memo is empty
            if (this.exChangeMemo.length < 1) {
              utils.showAlert(this.$t('message.tips'), this.$t('message.enter_exChange_memo_tips'))
              return
            }
          }
          if (utils.checkIsBnbExchangeAddr(this.swapAddress) && utils.checkIsSwapToBep2(this.curSwapType) && !utils.isValidBnbExchangeMemo(this.exChangeMemo)) {
            utils.showAlert(this.$t('message.tips'), this.$t('message.invalid_bnb_exChange_memo_tips'))
            return
          }
          if (this.isQuerying) {
            return
          }
          this.isQuerying = true
          this.mdLoadingDisplayState(true)
          let result = await webAPI.getDepositInfo(this.curSwapType, this.swapAddress, this.exChangeMemo)
          this.mdLoadingDisplayState(false)
          if (utils.checkIsNotNullObj(result.res)) {
            this.depositInfo = result.res || {}
            this.depositInfo[utils.swapTypeKey] = this.curSwapType
            this.depositInfo[utils.swapAddressKey] = this.swapAddress
            this.depositInfo[utils.exChangeMemo] = this.exChangeMemo
            this.curStage = utils.SwapStage.SwapStageGetDepositInfo
          } else {
            utils.showAlert(this.$t('message.tips'), this.getErrorTipsByErrCode(result.errCode))
            console.log('Fail to fetch deposit info,the error code is %s, msg is %s', result.errCode, result.errMsg)
          }
          this.isQuerying = false
        }
      } else if (this.checkIsGetDepositInfoStage()) {
        // if (this.isQuerying) {
        //   return
        // }
        // this.isQuerying = true
        // // if current stage is SwapStageGetDepositInfo,when click next, start swap and success then enter stage SwapStageSwap
        // this.mdLoadingDisplayState(true)
        // let result = await webAPI.startSwap(this.curSwapType, this.swapAddress)
        // this.mdLoadingDisplayState(false)
        // if (utils.checkIsNotNullObj(result.res)) {
        //   this.swapResult = result.res || []
        //   this.curStage = utils.SwapStage.SwapStageSwap
        // } else {
        //   utils.showAlert('Processing', result.errMsg)
        //   console.log('Fail to swap,the error code is %s, msg is %s', result.errCode, result.errMsg)
        // }
        // this.isQuerying = false
        this.curStage = utils.SwapStage.SwapStageGetTokenList
      } else if (this.checkIsSwapStage()) {
        // if current stage is SwapStageSwap,when click next, start swap and then reenter stage SwapStageGetTokenList
        this.curStage = utils.SwapStage.SwapStageGetTokenList
      }
    },

    async queryTokenList () {
      // query swap token list from server
      this.mdLoadingDisplayState(true)
      let result = await webAPI.getSwapTokenList()
      this.mdLoadingDisplayState(false)
      if (utils.checkIsNotNullObj(result.res)) {
        this.tokenList = result.res || []
      } else {
        utils.showAlert('Fail to get token list', result.errMsg)
        console.log('Fail to fetch swap token list,the error code is %s, msg is %s', result.errCode, result.errMsg)
      }
    },

    async checkServiceStatus () {
      // query swap token list from server
      this.mdLoadingDisplayState(true)
      let result = await webAPI.isServiceAvailable()
      this.mdLoadingDisplayState(false)
      if (utils.checkIsNotNullObj(result.res)) {
        this.serviceAvailable = result.res || false
      } else {
        utils.showAlert('Failed to get service status')
      }
    },

    mdLoadingDisplayState (isShow) {
      this.isShowLoading = isShow
    },

    getErrorTipsByErrCode (code) {
      if (code === utils.netErrorCode.netErrorCodeSystemError) {
        return this.$t('message.swap_system_error')
      } else if (code === utils.netErrorCode.netErrorCodeSwapAddressInvalid) {
        return this.$t('message.swap_address_invalid')
      } else if (code === utils.netErrorCode.netErrorCodeSwapAddressNotExist) {
        return this.$t('message.swap_address_not_exit')
      } else if (code === utils.netErrorCode.netErrorCodeInvalidSwapType) {
        return this.$t('message.swap_type_invalid')
      } else if (code === utils.netErrorCode.netErrorCodeInvalidExchangeMemo) {
        return this.$t('message.swap_memo_invalid')
      }
      return this.$t('message.swap_unknown_error')
    }

  },
  created () {
  },
  async mounted () {
    console.log('current env is', process.env.NODE_ENV)
    this.curLanguageType = this.getCurrentLanguageType()
    this.curLanguage = this.getCurrentLanguage()
    await this.checkServiceStatus()
    this.queryTokenList()
  }
}
</script>

<style>
  .app_container {
    width: 100%;
    background-color: #fff;
  }

  .desc_container {
    box-sizing: border-box;
    width: 100%;
    margin: 30px auto;
    padding: 0 30px;
    text-align: center;
    clear: both;
  }

  .logo {
    width: 164px;
    height: 141px;
    margin: 1em
  }

  .desc_text {
    color: #6a6a6a;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
  }

  .language_bg {
    display: flex;
    display: -ms-flex;
    flex-direction: row;
    align-items: center;
    float: right;
    margin-right: 50px;
  }

  .language-arrow-down {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #bfbfbf;
    margin-left: 5px;
    margin-top: 2px;
  }

  .operate_container {
    width: 100%;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }

  .out_of_service {
    width: 80%;
    max-width: 768px;
    margin: 60px auto;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }

  .service_mail {
    margin-top: 20px;
    margin-bottom: 30px;
    text-align: center;
  }

  .next_btn {
    margin-top: 80px;
    width: 50%;
    max-width: 480px;
    padding: 15px 0;
    outline-style: none;
    border-style: none;
    background-color: #007bff;
    border-radius: 4px;
    color: white;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .next_btn:hover {
    opacity: 0.6;
  }

  .next_btn:active {
    opacity:1;
  }

  .startOverBtn {
    margin-top: 60px;
    outline-style: none;
    border-style: none;
    background-color: white;
    text-decoration: underline;
    color: black;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .startOverBtn:hover {
    opacity: 0.6;
  }

  .startOverBtn:active {
    opacity:1;
  }

  .records_link {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 50%;
    max-width: 480px;
    padding: 15px 0;
    border: 2px solid #007bff;
    border-radius: 4px;
    background-color: #fff;
    color: #007bff;
    font-weight: 600;
    font-size: 16px;
    text-decoration: none;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .records_link:hover {
    opacity: 0.6;
  }

  .records_link:active {
    opacity: 1;
  }

  .new_badge {
    display: inline-block;
    padding: 2px 8px;
    background-color: #ff4d4f;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 1.4;
  }

  .el-footer {
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  @media (max-width: 768px) {
    .next_btn,
    .records_link {
      width: 80%;
    }
  }
</style>
